import { ConsoleTrackingAdapter } from './adapters/console-tracking-adapter';
import { NoopTrackingAdapter } from './adapters/noop-tracking-adapter';
import type { TrackingAdapter } from './tracking-adapter';

/**
 * Creates the appropriate tracking adapter based on environment and configuration
 */
export function getTrackingAdapter(): TrackingAdapter {
  // Placeholder for future concrete adapter (e.g. Amplitude, GTM, etc.)

  // Use Console adapter in development if not using a real provider
  if (import.meta.env.DEV) {
    return new ConsoleTrackingAdapter();
  }

  // Fallback to Noop for production if no provider is configured
  return new NoopTrackingAdapter();
}
